import React from 'react';
import { motion } from 'framer-motion';
import { services, servicesContent } from '../../data';
import './Services.css';

const fadeUp = {
  hidden: { opacity: 0, y: 36 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.8, ease: [0.16, 1, 0.3, 1] },
  },
};

const Services = () => {
  return (
    <section id="services" className="services section">
      <div className="container">
        {/* Header */}
        <motion.div
          className="services-header"
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: '-80px' }}
        >
          <div>
            <span className="section-eyebrow">{servicesContent.label}</span>
            <h2 className="section-heading">
              {servicesContent.title.split(servicesContent.titleHighlight)[0]}
              <span className="accent">{servicesContent.titleHighlight}</span>
            </h2>
          </div>
          <p className="services-subtitle">{servicesContent.subtitle}</p>
        </motion.div>

        {/* Cards */}
        <div className="services-grid">
          {services.map((service, index) => (
            <motion.article
              key={service.id}
              className="service-card"
              initial={{ opacity: 0, y: 44 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-40px' }}
              transition={{ delay: (index % 3) * 0.12, duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
            >
              <div className="service-media">
                <img src={service.image} alt={service.title} loading="lazy" />
                <span className="service-index">0{index + 1}</span>
              </div>
              <div className="service-body">
                <h3 className="service-title">{service.title}</h3>
                <p className="service-description">{service.description}</p>
                <ul className="service-features">
                  {service.features.map((feature) => (
                    <li key={feature}>{feature}</li>
                  ))}
                </ul>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
